import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Layout.css';

// Logo Bolcoin
const BolcoinLogo = () => (
  <svg viewBox="0 0 100 100" className="bolcoin-logo" width="32" height="32">
    <circle cx="50" cy="50" r="44" fill="none" stroke="#22c55e" strokeWidth="6"/>
    <circle cx="50" cy="50" r="12" fill="#22c55e"/>
  </svg>
);

const CURRENT_YEAR = new Date().getFullYear();

function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="site-footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-section footer-brand">
            <Link to="/" className="footer-logo">
              <BolcoinLogo />
              <span>BOLCOIN</span>
            </Link>
            <p className="footer-tagline">
              {t('footer.tagline')}
            </p>
            <div className="footer-network">
              <span className="network-badge">
                <span className="network-dot"></span>
                {t('footer.polygon_network')}
              </span>
            </div>
          </div>

          {/* Games Section */}
          <div className="footer-section">
            <h4 className="footer-title">{t('footer.games')}</h4>
            <ul className="footer-links">
              <li><Link to="/bet">{t('footer.la_bolita_full')}</Link></li>
              <li><Link to="/lottery">{t('footer.la_fortuna_full')}</Link></li>
              <li><Link to="/keno">{t('footer.keno_instant')}</Link></li>
              <li><Link to="/claims">{t('footer.my_prizes')}</Link></li>
              <li><Link to="/results">{t('footer.results')}</Link></li>
              <li><Link to="/referrals">{t('footer.referral_program')}</Link></li>
            </ul>
          </div>

          {/* Platform Section */}
          <div className="footer-section">
            <h4 className="footer-title">{t('footer.platform')}</h4>
            <ul className="footer-links">
              <li><Link to="/how-it-works">{t('footer.how_it_works')}</Link></li>
              <li><Link to="/transparency">{t('footer.transparency')}</Link></li>
              <li><Link to="/fairness">{t('footer.provably_fair')}</Link></li>
              <li><Link to="/faq">{t('footer.faq')}</Link></li>
              <li><Link to="/official-links">{t('footer.official_links')}</Link></li>
            </ul>
          </div>

          {/* Legal Section */}
          <div className="footer-section">
            <h4 className="footer-title">{t('footer.legal')}</h4>
            <ul className="footer-links">
              <li><Link to="/legal/terms">{t('footer.terms')}</Link></li>
              <li><Link to="/legal/rules">{t('footer.game_rules')}</Link></li>
              <li><Link to="/legal/privacy">{t('footer.privacy')}</Link></li>
              <li><Link to="/legal/cookies">{t('footer.cookies')}</Link></li>
              <li><Link to="/legal/responsible-gaming">{t('footer.responsible_gaming')}</Link></li>
              <li><Link to="/legal/jurisdictions">{t('footer.restricted_jurisdictions')}</Link></li>
              <li><Link to="/legal/disclaimer">{t('footer.disclaimer')}</Link></li>
            </ul>
          </div>

          {/* Support Section */}
          <div className="footer-section">
            <h4 className="footer-title">{t('footer.support')}</h4>
            <ul className="footer-links">
              <li><Link to="/contact">{t('footer.contact_us')}</Link></li>
              <li>
                <a href="https://t.me/labolita" target="_blank" rel="noopener noreferrer">
                  {t('footer.telegram')}
                </a>
              </li>
              <li>
                <a href="https://twitter.com/labolita" target="_blank" rel="noopener noreferrer">
                  {t('footer.twitter')}
                </a>
              </li>
              <li>
                <a href="https://discord.gg/Dg54xsww8z" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
                  </svg>
                  Discord
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="footer-trust">
          <div className="trust-item">
            <span className="trust-icon">{'\uD83D\uDD12'}</span>
            <span>{t('footer.non_custodial')}</span>
          </div>
          <div className="trust-item">
            <span className="trust-icon">{'\uD83C\uDFB2'}</span>
            <span>{t('footer.chainlink_vrf')}</span>
          </div>
          <div className="trust-item">
            <span className="trust-icon">{'\uD83D\uDCDC'}</span>
            <span>{t('footer.open_source')}</span>
          </div>
          <div className="trust-item">
            <span className="trust-icon">{'\u26D3\uFE0F'}</span>
            <span>{t('footer.on_chain')}</span>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>{t('footer.copyright', { year: CURRENT_YEAR })}</p>
            <p className="footer-disclaimer-short">
              {t('footer.gambling_disclaimer')}
            </p>
          </div>
          <div className="footer-contracts">
            <span className="contract-label">{t('footer.contracts_verified')}</span>
            <a
              href="https://polygonscan.com"
              target="_blank"
              rel="noopener noreferrer"
              className="contract-link"
            >
              PolygonScan
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
